<div class="d-flex flex-column" *ngFor="let consent of consents">
  <div class="custom-control custom-checkbox">
    <input
      type="checkbox"
      class="custom-control-input"
      [id]="'policy-consent-' + consent.id"
      [(ngModel)]="consent.checked"
      (ngModelChange)="onCheckboxChange()"
    />
    <label class="custom-control-label" [for]="'policy-consent-' + consent.id">
      <ng-container *ngFor="let part of consent.labelParts">
        <span *ngIf="part.type === policyLabelPartTypes.Text">{{ part.text }}</span>
        <a
          *ngIf="part.type === policyLabelPartTypes.Link"
          [href]="part.url"
          target="_blank"
          rel="noopener"
        >
          {{ part.text }}
        </a>
      </ng-container>
      <span *ngIf="consent.isRequired" class="required-asterisk">*</span>
    </label>
  </div>
</div>
